<template lang="pug">
  .page-container
    .app-breadcrumbs.center-breadcrumbs
      v-container.breadcrumbs-container.center-container
        img.breadcrumbs-logo(src="../../assets/logo.png")/
        v-breadcrumbs(:items="breadcrumbs")
          template(slot="item" slot-scope="props")
            router-link(
              :to="props.item.to"
              class="app-breadcrumbs__item"
            ) {{ props.item.text }}

    v-container
      v-layout.map-container
        v-flex(xs10)
          img.map(src='../../assets/map.png')
        v-flex(xs6)
          .store-info
            .title {{ $t("contactUs.address") }}
            .little-title {{ $t("contactUs.organicStore") }}
            .don-store {{ $t("contactUs.donFrutaStore") }}
            .address {{ shopInfo.address }}
            .contact(v-if="shopInfo.tel")
              .label {{ $t("contactUs.call") }}
              .content {{ shopInfo.tel }}
            .contact(v-if="shopInfo.email")
              .label {{ $t("contactUs.email") }}
              .content {{ shopInfo.email }}

    v-container
      .form-container
        .contact-title {{ $t("contactUs.contactDonFruta") }}
        .little-title {{ $t("contactUs.organicStore") }}

      v-form.form-content(ref="form")
        v-layout.first-row(justify-space-between)
          v-flex.input-wrapper(xs8)
            v-text-field(
              :label='$t("contactUs.nickname")'
              :rules="fieldRules"
              outline
              v-model="nickname"
              ref="nickname"
            )
          v-flex.input-wrapper(xs8)
            v-text-field(
              :label='$t("contactUs.phoneNumber")'
              :rules="fieldRules"
              outline
              v-model="phone"
              ref="phone"
            )
          v-flex.input-wrapper(xs8)
            v-text-field(
              :rules="fieldRules"
              :label='$t("contactUs.email")'
              outline
              v-model="email"
              ref="email"
            )
        v-layout.second-row
          v-flex(xs8)
            v-textarea(
              :rules="fieldRules"
              :label='$t("contactUs.content")'
              outline
              v-model="content"
              ref="content"
              )

        v-btn.btn(color="primary" round block @click="submit" :loading='isLoading') {{ $t("contactUs.send") }}

</template>

<script>
import common from "../../api/common.js";

export default {
  data() {
    return {
      isLoading: false,
      nickname: null,
      phone: null,
      email: null,
      content: null,
      shopInfo: {}
    };
  },

  mounted() {
    this.loadShopInfo();
  },

  computed: {
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("nav.home")
        },
        {
          to: { name: "contact-us" },
          disabled: false,
          text: this.$t("nav.contactUs")
        }
      ];
    },
    fieldRules() {
      return [value => !!value || this.$t("contactUs.required")];
    },
    form() {
      return {
        nickname: this.nickname,
        phone: this.phone,
        email: this.email,
        content: this.content
      };
    }
  },
  methods: {
    submit() {
      let formHasErrors = true;
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) {
          this.$refs[f].validate(true);
          formHasErrors = false;
        }
      });

      if (formHasErrors) {
        this.handleSubmit();
      }
    },
    async handleSubmit() {
      this.isLoading = true;
      try {
        const res = await common.feedbackAdd({ ...this.form });
        this.isLoading = false;
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.$toasted.success(this.$t("contactUs.sendSuccess"));
        }
      } catch (e) {
        console.log(e);
      }
    },

    async loadShopInfo() {
      try {
        const res = await common.loadShopInfo({ shopId: 1 });
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.shopInfo = res.data.data;
          this.shopInfo.intro = res.data.data.intro.replace(/\r\n/g, "<br/>");
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style scoped lang="sass" src="./contact-us.sass"></style>
